exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._plane__plane__22T0Q {\n  margin: auto;\n  animation: _plane__sk-rotatePlane__2nNEd 1.2s infinite ease-in-out; }\n\n@keyframes _plane__sk-rotatePlane__2nNEd {\n  0% {\n    transform: perspective(120px) rotateX(0deg) rotateY(0deg); }\n  50% {\n    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg); }\n  100% {\n    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg); } }\n", ""]);

// exports
exports.locals = {
	"plane": "_plane__plane__22T0Q",
	"sk-rotatePlane": "_plane__sk-rotatePlane__2nNEd"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]__[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/rctui/styles/spin/_plane.scss
// module id = 418
// module chunks = 0 1